/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Headline = 'Website.Booking.MyProfile.BookingDetailsView.FutureBooking.EditModal.Headline';
export const RescheduledToast = 'Website.Booking.MyProfile.BookingDetailsView.FutureBooking.EditModal.RescheduledToast';
